import React from 'react'
import { Provider } from 'react-redux'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import i18n from 'live/services/i18n'
import Store from '../../store'
import timelineContainer from '../containers/timeline-redux-container'
import ButtonSvg from '../../../assets/timeline.svg'
import MenuButton from 'live/components/dashboard/MenuButton'

export default class TimelineViewMainHeaderButtonProvider extends React.Component {

    constructor (props) {
        super(props)
        this.props = props
    }

    render () {
        let TimelineViewMainHeaderButtonContainer = timelineContainer(TimelineViewMainHeaderButton)

        return (
            <Provider store={Store}>
                <TimelineViewMainHeaderButtonContainer {...this.props} />
            </Provider>
        )
    }

}

type TimelineViewMainHeaderButtonProps = {
    dashboardId?: number
    publicMode?: boolean
    userTimelineVisible?: boolean
    timelineConfig?: {
        disabled?: boolean
        mode?: string
    }
    saveUserTimelineVisibility?: (dashboardId: number, userTimelineVisible: boolean) => void
}

class TimelineViewMainHeaderButton extends React.Component<TimelineViewMainHeaderButtonProps> {

    constructor (props) {
        super(props)
        this.props = props
    }

    render () {
        let { publicMode, userTimelineVisible, timelineConfig, saveUserTimelineVisibility, dashboardId } = this.props
        let { disabled } = timelineConfig

        return (
            <li style={{ display: !disabled ? 'inline' : 'none' }}>
                {!disabled ? (
                    <OverlayTrigger
                        placement="bottom"
                        overlay={
                            <Tooltip id="no-index">
                                {userTimelineVisible ? i18n('Toggle Timeline off') : i18n('Toggle Timeline on')}
                            </Tooltip>
                        }
                    >
                        <MenuButton
                            disabled={publicMode}
                            active={userTimelineVisible && !publicMode}
                            onClick={() => saveUserTimelineVisibility(dashboardId, !userTimelineVisible)}
                        >
                            <i>
                                <ButtonSvg />
                            </i>
                        </MenuButton>
                    </OverlayTrigger>
                ) : null}
            </li>
        )
    }
}
